// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Cuidando do cérebro em todas as fases da vida.</b></h2>
                <br/>
                <p>A Neurologia Adulta é a especialidade médica voltada ao diagnóstico, tratamento e acompanhamento de doenças que afetam o sistema nervoso central e periférico em adultos. Com foco na preservação das funções neurológicas e na promoção da qualidade de vida, a especialidade abrange desde quadros mais simples, como enxaquecas, até condições mais complexas, como AVC, esclerose múltipla, epilepsia e doenças neurodegenerativas.</p> 
                <br /> 
                <p>O neurologista adulto atua de forma integrada, avaliando sinais como alterações na memória, dificuldades motoras, dormência, tremores, tonturas, entre outros sintomas que impactam diretamente o bem-estar, a autonomia e a rotina dos pacientes.</p> 
                <br /> 
                <p><b>Quando procurar um neurologista adulto?</b></p> 
                <br />
                <p>A avaliação neurológica é recomendada em situações como:</p>
                <li>Dores de cabeça frequentes, enxaquecas intensas ou persistentes;</li>
                <li>Alterações na memória, confusão mental ou desorientação;</li>
                <li>Formigamentos, fraqueza ou perda de força muscular;</li>
                <li>Convulsões, desmaios ou crises epilépticas;</li>
                <li>Tremores, desequilíbrio ou dificuldade para andar;</li>
                <li>Diagnóstico ou suspeita de doenças como Parkinson, Alzheimer, AVC ou esclerose múltipla.</li>
                <br/>
                <p><b>Benefícios do acompanhamento neurológico em adultos</b></p>
                <br/>
                <p>O tratamento com um neurologista oferece uma série de vantagens para a saúde e o bem-estar, como:</p>
                <li>Diagnóstico precoce de doenças neurológicas, possibilitando intervenções mais eficazes;</li>
                <li>Redução da progressão de doenças crônicas e melhora da qualidade de vida;</li>
                <li>Alívio de sintomas incapacitantes, como dores e alterações motoras;</li>
                <li>Acompanhamento humanizado e suporte multidisciplinar para o paciente e seus familiares;</li>
                <br/>
                <p><b>Neurologia adulta: promovendo saúde, equilíbrio e autonomia</b></p>
                <br/>
                <p>A neurologia adulta vai além do tratamento — ela representa um cuidado contínuo com a mente e o corpo. Com acompanhamento especializado, é possível manter a saúde neurológica em todas as fases da vida, prevenir complicações e proporcionar bem-estar físico, emocional e cognitivo para quem enfrenta desafios neurológicos.</p>
            </div>
        </div>
    </section>
);

export default NeurologistaInfo;